import TableHead from '@material-ui/core/TableHead/TableHead';
import {useTranslation} from 'react-i18next';
import StandardRow from './StandardRow';

const Header = () => {
  const {t} = useTranslation();
  
  return (
    <TableHead>
      <StandardRow 
        header
        cells={[
          {value: t('search-results.name')},
          {value: t('search-results.type')},
          {value: t('search-results.locales')} 
        ]} />
    </TableHead>
  );
}

export default Header
